import { IEntity } from "@interfaces/entity";
import { Type } from "class-transformer";
import { BankDetails } from "./bankDetails";
import { Operator } from "./operator";
import { Subscription } from "./subscription";
import { StripeInfo } from "./stripeInfo";
import { User } from "./identity/user";
import { UserDto } from "../dto/userDto";

export class Customer implements IEntity{
  id: number;

  customerId: number;
  name: string;
  email: string;

  internalDescription: string;

  contactPerson: string;

  masterRfidCardIdTag: string;

  @Type(() => BankDetails)
  bankDetails: BankDetails;

  @Type(() => Operator)
  operator: Operator;
  operatorId: number;

  @Type(() => UserDto)
  users: UserDto;
  usersId: number;

  @Type(() => StripeInfo)
  stripeInfo: StripeInfo;
  stripeInfoId: number;

  @Type(() => Subscription)
  subscription: Subscription;
  subscriptionId: number;


  entityName = "Customer";

  constructor(formValue?: Partial<Customer>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<Customer>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }
}
